import { connectFirestoreEmulator, getFirestore, initializeFirestore } from "firebase/firestore";
import { app } from "./initialize-app";

// https://stackoverflow.com/a/70585365/8895077
initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});
// export const fsDb = getFirestore(app, process.env.NEXT_PUBLIC_FIREBASE_DB_ID);

// TODO: Temporarily hardcoded Firestore database ID for development purposes.
export const fsDb = getFirestore(app, "production");

// Connect to the Auth Emulator
process.env.NODE_ENV !== "production" &&
  process.env.NEXT_PUBLIC_FIREBASE_USE_EMULATOR === "true" &&
  connectFirestoreEmulator(fsDb, "0.0.0.0", 8080);
